export const cardSx = { height: "100%", borderRadius: 3 };

export const contentSx = {
  p: { xs: 4, md: 5 },
};